import icon from 'vue-svgicon';

icon.register({
    'regular/shop': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M21.75 12.75v9a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-9M21.148.75H2.852a.751.751 0 0 0-.733.587L.75 7.5a2.25 2.25 0 0 0 4.5 0 2.25 2.25 0 0 0 4.5 0 2.25 2.25 0 0 0 4.5 0 2.25 2.25 0 0 0 4.5 0 2.25 2.25 0 0 0 4.5 0l-1.37-6.163a.749.749 0 0 0-.732-.587zM2.25 17.25H15M15 23.25v-10.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
